import { Signal } from "@lit-labs/signals";
import type { IBackofficeFeatureFlagsState } from "./types";

export class BackofficeFeatureFlagsState implements IBackofficeFeatureFlagsState {
  readonly features = new Signal.State<string[]>([]);
  readonly loading = new Signal.State<boolean>(false);

  hasFeature(name: string): boolean {
    return this.features.get().includes(name);
  }
}
